export const auth = {
  loginTitle: 'Entrar',
  loginSubtitle: 'Acesse sua conta para continuar.',
  tagline: 'Sua plataforma de backoffice.',
  email: 'E-mail',
  password: 'Senha',
  submit: 'Entrar',
  passwordShow: 'Mostrar senha',
  passwordHide: 'Ocultar senha',
  azureSignIn: 'Entrar com Microsoft',
  orContinueWith: 'ou continue com e-mail',
  invalidCredentials: 'E-mail ou senha inválidos.',
  azureCallbackPending: 'Concluindo login com a Microsoft...',
  azureCallbackFailed: 'Não foi possível concluir o login. Tente novamente.',
  logout: 'Sair',
  validation: {
    invalidEmail: 'E-mail inválido',
    passwordTooShort: 'A senha deve ter pelo menos 8 caracteres',
  },
} as const;
